<template>
    <div class="pagingContainer">
        <router-link :to="`/search/list/${prev}`">
            <svg width="36px" height="36px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                <circle cx="256" cy="256" r="230" stroke="black" stroke-width="32" fill="none" />
                <polyline points="300,128 172,256 300,384" fill="none" stroke-width="32" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </router-link>

        Oferty - strona {{ current }} z {{ max }}

        <router-link :to="`/search/list/${next}`">
            <svg width="36px" height="36px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                <circle cx="256" cy="256" r="230" stroke="black" stroke-width="32" fill="none" />
                <polyline points="212,128 340,256 212,384" fill="none" stroke-width="32" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </router-link>
    </div>
</template>

<script>
export default {
    name: "PagingBox",
    props: {
        current: {
            required: false
        },
        max: {
            required: false
        }
    },
    computed: {
        next () {
            return parseInt(this.current) + 1 > this.max ? this.max : parseInt(this.current) + 1;
        },
        prev () {
            return parseInt(this.current) - 1 < 1 ? 1 : parseInt(this.current) - 1;
        }
    }
}
</script>

<style scoped lang="scss">
.pagingContainer {
    max-width: 1200px;
    margin: 10px auto;
    background: #ffffff;
    padding: 20px;
    font: 32px/36px "Google Sans";
    vertical-align: top;

    a {
        vertical-align: top;
    }

    svg {
        vertical-align: top;
        margin: 0 15px;
    }
}
@media screen and (max-width: 800px) {
    .pagingContainer {
        font: 24px/36px "Google Sans";
    }
    svg {
        vertical-align: top;
        margin: 0 10px;
    }
}
</style>